export default __webpack_public_path__ + "static/media/noun-remove.79fb1e04.svg";